<script setup lang="ts">
// SWOIS design-system form section — shared by every edit/create screen
// (courses, events, …). Two layouts:
// - default: title + subtitle in the left column, content slot on the right.
// - stacked: title + subtitle header on top, content slot full-width below
//   (e.g. a list/table that needs the whole width).
// In both layouts the subtitle sits directly under the title.
defineProps<{
  title: string;
  description?: string;
  stacked?: boolean;
}>();
</script>

<template>
  <section v-if="stacked" class="sw-card sw-card--pad">
    <div class="form-section__head">
      <div class="swois-ecard__l-title">{{ title }}</div>
      <div
        v-if="description"
        class="swois-ecard__l-desc form-section__desc"
      >
        {{ description }}
      </div>
    </div>
    <slot />
  </section>

  <section v-else class="sw-card sw-card--pad swois-ecard">
    <div class="swois-ecard__l">
      <div class="swois-ecard__l-title">{{ title }}</div>
      <div
        v-if="description"
        class="swois-ecard__l-desc form-section__desc"
      >
        {{ description }}
      </div>
    </div>
    <div class="swois-ecard__r">
      <slot />
    </div>
  </section>
</template>

<style scoped>
.form-section__head {
  margin-bottom: 16px;
}
/* Pin the subtitle directly under the title instead of the DS default
   (margin-top:auto), which pushes it to the bottom of the left column. */
.form-section__desc {
  margin-top: 6px;
  padding-top: 0;
}
</style>
